export default {
  groups: {
    dashboards: 'Dashboards',
    online_shop: 'Loja Online',
    home: 'Início',
    marketing: 'Marketing',
    reservations: 'Reservas',
    website: 'Website',
    orders_portal: 'Abrir portal de encomendas',
    roi: 'ROI',
    google_ads: 'Google Ads',
    mobile_app: 'Aplicação Móvel',
    phone_answering: 'Atendimento Telefónico',
    pricing: 'Preços',
    team: 'Equipa',
    data_deletion_requests: 'Pedidos de eliminação de dados',
    partner: 'Parceiro',
  },
  get_started: {
    title: 'Começar',
  },
  onboarding: {
    title: 'Lançamento',
  },
  new_restaurant: {
    title: 'Novo Restaurante',
  },
  gift_cards: {
    title: 'Cartões Oferta',
  },
  top_items: {
    title: 'Itens Mais Vendidos',
  },
  dashboards: {
    title: 'Dashboards',
    children: {
      general: 'Geral',
      restaurant_details: 'Detalhes do Restaurante',
      external_delivery: 'Entrega Externa',
      overview: 'Visão Geral',
      orders: 'Encomendas por origem',
      google: 'Google',
      customers: 'Clientes',
    },
  },
  customer_base: {
    title: 'Base de Clientes',
  },
  new_company: {
    title: 'Novo restaurante',
  },
  agent_ops_queue: {
    title: 'Sugestões de IA',
  },
  external_delivery_support: {
    title: 'Suporte de entrega externa',
  },
  payment_gateways: {
    title: 'Gateways de Pagamento',
  },
  developers: {
    title: 'Programadores',
  },
  feature_flags: {
    title: 'Funcionalidades',
  },
  test_restaurants: {
    title: 'Restaurantes de teste',
  },
  partners: {
    title: 'Parceiros',
  },
  partner: {
    children: {
      account: 'Conta',
      branding: 'Identidade visual',
      payment_gateway: 'Gateway de pagamento',
      billing: 'Faturação',
      tax_currency: 'Impostos e Moeda',
      service_fee_calculator: 'Calculadora da taxa de serviço',
      processing_fees: 'Taxas de processamento',
    },
  },
  going_live: {
    title: 'Entrar em produção',
    children: {
      setup_package_fulfillments: 'Cumprimentos Logsta',
      polygraphy: 'Produtos de Impressão',
    },
  },
  franchises: {
    title: 'Marcas',
  },
  setup_package_fulfillments: {
    title: 'Cumprimento de pacotes de configuração',
  },
  website: {
    title: 'Website',
    children: {
      storefront: 'Loja',
      studio: 'Studio (V1)',
      studio_v2: 'Studio (V2)',
    },
  },
  reservations: {
    title: 'Reserva',
    children: {
      overview: 'Visão Geral',
      booking_availability: 'Disponibilidade de Reservas',
      settings: 'Definições',
      general: 'Geral',
      storefront: 'Loja',
    },
  },
  subscriptions: {
    title: 'Subscrições',
    children: {
      subscriptions: 'Subscrições',
      products: 'Produtos',
    },
  },
  sales: {
    title: 'Vendas',
    children: {
      orders: 'Encomendas',
      receipts: 'Recibos de clientes',
      external_deliveries: 'Entregas externas',
    },
  },
  billing: {
    title: 'Relatórios',
    children: {
      monthly_statements: 'Extratos Mensais',
      payouts: 'Pagamentos',
      invoices: 'Faturas',
      subscription: 'Subscrição',
      sales_summary: 'Resumo de Vendas',
      internal_invoice_items: 'Itens de fatura internos',
      income_reports: 'Relatórios de receitas',
      tax_reports: 'Relatórios fiscais',
    },
  },
  master_menu: {
    title: 'Sincronização de marca',
  },
  menu: {
    title: 'Menu',
    children: {
      master_overview: 'Marcas',
      manage_menus: 'Gerir menus',
      modifiers: 'Modificadores',
      smart_pricing: 'Preços dinâmicos',
      upsell_items: 'Itens de upsell',
      sold_out_items: 'Itens esgotados',
      import: 'Importar',
      edit_history: 'Histórico de edições',
    },
  },
  my_store: {
    title: 'Os meus dados',
    children: {
      settings: 'Perfil',
      gallery: 'Galeria',
      business_information: 'Informação Empresarial',
      documents: 'Os meus documentos',
      personal_information: 'Informação Pessoal',
      bank_info: 'Dados Bancários',
      tax_info: 'Dados Fiscais',
      shipping_info: 'Dados de Envio',
      google_profile: 'Perfil Google',
      seo: 'SEO',
      impressum: 'Impressum',
      imprint: 'Informação legal',
      post_launch: 'Pós-Lançamento',
      tax_currency: 'Impostos e Moeda',
    },
  },
  opening_hours: {
    title: 'Horários e Localização',
    children: {
      opening_hours: 'Horários de funcionamento',
      location: 'Localização',
    },
  },
  order_settings: {
    title: 'Definições de encomenda',
    children: {
      takeout: 'Métodos de Encomenda',
      order_layout: 'Disposição da Encomenda',
      payment_methods: 'Métodos de pagamento',
      connect_paypal: 'Ligar PayPal',
      tips: 'Gorjetas',
      service_fee: 'Taxas',
      processing_fees: 'Taxas de processamento',
      receipt: 'Recibo',
      staff_credentials: 'Credenciais do pessoal',
      integrations: 'Integrações',
      terminal: 'Terminal',
      invoices: 'Faturas',
    },
  },
  mobile_app: {
    title: 'Aplicação Móvel',
    children: {
      overview: 'Visão Geral',
      updates: 'Atualizações',
      intro_screen: 'Ecrã de Introdução',
    },
  },
  marketing: {
    children: {
      overview: 'Visão Geral',
      followers: 'Seguidores',
      email_messages: 'Mensagens de e-mail',
      push_notifications: 'Notificações push',
      promo_codes: 'Códigos promocionais',
      offers: 'Ofertas',
      google_business: 'Google Business',
      google_review_program: 'Programa de avaliações Google',
      loyalty_program: 'Programa de fidelização',
      polygraphy: 'Produtos de Impressão',
      tracking_links: 'Links de Rastreamento',
      google_ads: 'Google Ads',
      website_analytics: 'Análise do Website',
      featured_posts: 'Posts Aplicação Móvel',
    },
  },
  loyalty_tablet: {
    title: 'Tablet de Fidelização',
    children: {
      dashboard: 'Dashboard',
      settings: 'Definições',
      credentials: 'Credenciais',
    },
  },
  contract: {
    title: 'Contrato',
    children: {
      agreement: 'Acordo',
      template: 'Modelo',
    },
  },
  team: {
    children: {
      managers: 'Gestores',
      reports: 'Relatórios',
    },
  },
};
